<!--
 * @Author: your name
 * @Date: 2021-12-03 09:13:47
 * @LastEditTime: 2022-01-26 18:16:22
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \new-website-1123\src\views\special\fx101\page8.vue
-->
<template>
  <div class="fx101-page8 pt80">
    <ctitle titleb="主体结构"></ctitle>
    <div class="img-div">
      <img
        class="data-img"
        src="https://stkjiot.com/resources/special/stld/13.png"
        alt="上太科技"
        @load="imgLoad"
      />
      <div class="i-desc lt-d">
        <span class="line-span"></span>
        <p class="line-label">路灯</p>
      </div>
      <div class="i-desc r-desc">
        <span class="line-span"></span>
        <p class="line-label">主体ABS</p>
        <p class="line-label c-g">高强度抗UV老化</p>
      </div>
      <div class="i-desc r-top">
        <span class="line-span"></span>
        <p class="line-label">太阳能板</p>
      </div>
      <div class="i-desc lb-d">
        <span class="line-span"></span>
        <p class="line-label">不锈钢</p>
      </div>
    </div>
  </div>
</template>

<script>
import ctitle from "@/components/sTitle/title1";
export default {
  name: "",
  components: {
    ctitle,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    imgLoad() {
      let div = document.querySelector(".fx101-page8");
      let img = div.querySelector(".data-img");
      let lp = div.querySelector(".lt-d");
      let lb = div.querySelector(".lb-d");
      let rp = div.querySelector(".r-desc");
      let rt = div.querySelector(".r-top");
      rp.style.left = `calc(50% + ${img.width / 12}px)`;
      rt.style.left = `calc(50% + ${img.width / 2}px - 6px)`;
      lp.style.right = `calc(50% + ${img.width / 3}px )`;
      lb.style.right = `calc(${img.width}px - ${img.width / 2.4}px)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.fx101-page8 {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 180px;
  .img-div {
    height: 80%;
    margin-top: 50px;
    position: relative;
    img {
      height: 100%;
    }
  }
}

.i-desc {
  position: absolute;
  top: 34%;
  overflow: hidden;
  &.r-desc {
    text-align: right;
    top: 49%;
  }
  &.r-top {
    text-align: right;
    top: 6%;
    p {
      padding-left: 144px;
    }
  }
  &.lb-d {
    top: 54%;
    .line-span {
      left: unset;
      right: 0;
    }
    .line-label {
      padding-left: 0;
      font-weight: bold;
      padding-right: 200px;
    }
  }
  &.lt-d {
    top: 6%;
    .line-span {
      left: unset;
      right: 0;
    }
    .line-label {
      font-weight: bold;
      padding-left: 0;
      padding-right: 162px;
    }
  }
  .line-span {
    display: block;
    position: absolute;
    top: 0px;
    left: 0;
    width: 200px;
    height: 1px;
    background-color: rgba($color: #fff, $alpha: 0.5);
  }
  p {
    margin: 0;
    white-space: nowrap;
    color: $color-active;
    padding-left: 100px;
    position: relative;
    height: 0;
    // height: 16px;
    margin-top: 10px;
    overflow: hidden;
    font-size: 22px;
    font-weight: bold;
    &.c-g {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
    }
  }
}
@media screen and (max-height: 800px) {
  .fx101-page8 {
    .img-div {
      height: 68%;
    }
  }
}
@media screen and (min-height: 800px) {
  .fx101-page8 {
    .img-div {
      height: 78%;
    }
  }
}

@media screen and (max-width: $mobile-width) {
  .fx101-page8 {
    margin-top: 1.64rem;
    height: auto;
    .img-div {
      height: unset;
      width: 100%;
      margin-top: 0.45rem;
      display: flex;
      justify-content: center;
      img {
        height: unset;
        width: 40%;
      }
    }
  }

  .i-desc {
    position: absolute;
    top: 34%;
    overflow: hidden;
    width: 2rem;
    &.r-top {
      p {
        padding-left: 0;
      }
    }
    &.lb-d {
      right: 52.5% !important;
      .line-label {
        padding-right: 0;
      }
    }
    &.lt-d {
      .line-label {
        padding-right: 0;
      }
    }
    .line-span {
      width: 100%;
      height: 1px;
      background-color: rgba($color: #fff, $alpha: 0.5);
    }
    p {
      margin: 0;
      padding-left: 0;
      height: auto;
      // height: 16px;
      margin-top: 6px;
      font-size: 0.27rem;
      &.c-g {
        font-size: 0.22rem;
        width: 90%;
        white-space: normal;
      }
    }
  }
}
</style>
